import { DateTimeUtcService } from '@mews/framework';

export const getUnixTimestampFromUtc = (utc: $TSFixMe) => {
    if (!utc) {
        return null;
    }

    return DateTimeUtcService.getEpoch(DateTimeUtcService.parse(utc)) / 1000;
};
